import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;

const api = axios.create({ baseURL: API, withCredentials: true });

// CSRF double-submit: echo the csrf_token cookie back as the X-CSRF-Token header.
function getCookie(name) {
  const m = document.cookie.match("(^|;)\\s*" + name + "=([^;]+)");
  return m ? decodeURIComponent(m[2]) : null;
}
api.interceptors.request.use((config) => {
  const t = getCookie("csrf_token");
  if (t) config.headers["X-CSRF-Token"] = t;
  return config;
});

// Silent access-token refresh: on 401, rotate the refresh token once and retry.
let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error?.response?.status;
    const url = original.url || "";
    const skip = url.includes("/auth/login") || url.includes("/auth/refresh") || url.includes("/auth/logout");
    if (status === 401 && !original._retry && !skip) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e) {
  const detail = e?.response?.data?.error;
  if (detail?.message) return detail.message;
  if (typeof detail === "string") return detail;
  return e?.message || "Något gick fel. Försök igen.";
}

export default api;
